
    <ng-template #template>
      <div (click)="onClose()">
        <a-overlay class="transparent" tabindex="1"></a-overlay>
        <a-context-container [usedInPortal]="true">
          <ng-content></ng-content>
        </a-context-container>
      </div>
    </ng-template>